import React, { FC, CSSProperties } from "react";
import styles from "./Tab.module.css";
import { TTabbedContentProps } from "types/TabbedContent";
import { Button } from "components/atoms";
import he from "he";
import { TextEditor } from "components/molecules";

type Icon = {
    Alt: string,
    Src: string,
    Height: string,
    Width: string,
    Rendered: any,
    MimeType: string,
    Size: number
}

export const TabbedContentMobile: FC<TTabbedContentProps> = ({
    handleChangeActiveModalItem,
    handleShowModal,
    children,
    tabTextColor = "white",
    DesktopImage,
    MobileImage,
    BackgroundColour,
    TabLinkPool,
    TextEditor: _TextEditor
}) => {

    const handleTabToggle = (icon: Icon, heading: string, summary: string, html: string, idx: number) => {
        handleChangeActiveModalItem(icon, heading, summary, html, idx);
        handleShowModal();
    };

    return (
        <div className={styles.wrapper}
            style={{ '--tabTextColor': tabTextColor } as CSSProperties}>
            {children}
            {/* Tabs Forword*/}
            <div className="mb-40">
                <TextEditor className={styles.tabForeword}
                    data={_TextEditor}
                />
            </div>
            {/* Tab Panels */}
            {
                TabLinkPool?.length && TabLinkPool.map((v, i) =>
                    <div className={styles.tabPanelContentWrapper}
                        key={'tabbed-content-mobile-' + v?.ContentHeading + i}
                    >
                        {/* Tab Panel Content Icon With Text */}
                        <div className={styles.tabPanelContentIconWithText}>
                            <h1>{he.decode(v.ContentHeading)}</h1>
                            <p className={styles.tabPanelContentSummary} dangerouslySetInnerHTML={{ __html: v.ContentSummary }}></p>
                            <Button
                                onClick={() => handleTabToggle(v.Icon, v.ContentHeading, v.ContentSummary, v.TextEditor, i)}
                                style={{ color: "#EFF0EF" }}
                                className={'noPadding autoH'}
                                as="button"
                                buttonStyle='chevron'>
                                READ MORE
                            </Button>
                        </div>

                    </div>
                )
            }
        </div >
    )
};